<template>
  <div class>
    <div class="flex relative">
      <div id="inputs" class="pr-8 text-left" style="border-right: 1px solid black;">
        <p class="py-2">
          <label for="name" class="block text-left pb-1 pl-1 font-sans font-bold">Name</label>
          <input v-model="name" class="border p-1" />
        </p>
        <p class="py-2">
          <label for="title" class="block text-left pb-1 pl-1 font-sans font-bold">Title</label>
          <input v-model="title" class="border p-1" />
        </p>
        <p class="py-2">
          <input type="checkbox" id="use-work-phone" v-model="useWorkPhone" class="inline-block" />
          <label
            for="workPhone"
            class="inline-block text-left pb-1 pl-1 font-sans font-bold"
          >Work Phone</label>
          <input v-model="workPhone" class="block border p-1" />
        </p>
        <p class="py-2">
          <input type="checkbox" id="use-cell-phone" v-model="useCellPhone" class="inline-block" />
          <label
            for="cellPhone"
            class="inline-block text-left pb-1 pl-1 font-sans font-bold"
          >Cell Phone</label>
          <input v-model="cellPhone" class="block border p-1" />
        </p>
        <p class="py-2">
          <input type="checkbox" id="use-skype" v-model="useSkype" class="inline-block" />
          <label
            for="cellPhone"
            class="inline-block text-left pb-1 pl-1 font-sans font-bold"
          >Skype Name</label>
          <input v-model="skype" class="block border p-1" />
        </p>
        <p class="py-2">
          <label for="email" class="block text-left pb-1 pl-1 font-sans font-bold">Email address</label>
          <input v-model="email" class="border p-1 w-64" />
        </p>
        <p class="py-2">
          <input
            type="checkbox"
            id="use-personal-twitter"
            v-model="usePersonalTwitter"
            class="inline-block"
          />
          <label
            for="twitterHandle"
            class="inline-block text-left pb-1 pl-1 font-sans font-bold"
          >Personal Twitter</label>
          <input v-model="twitterHandle" class="block border p-1" />
        </p>
        <p class="py-2">
          <input type="checkbox" id="use-linked-in" v-model="useLinkedIn" class="inline-block" />
          <label
            for="linkedIn"
            class="inline-block text-left pb-1 pl-1 font-sans font-bold"
          >LinkedIn</label>
          <span v-if="useLinkedIn">
            <label for="linkedInURL" class="block text-left pb-1 pl-1 pt-2 font-sans font-bold">
              Your LinkedIn URL
              <br />
              <span style="font-weight: 100;">(be sure to include "http://" or "https://")</span>
            </label>
            <input type="text" v-model="linkedInURL" class="block border p-1 w-64" />
            <label
              for="linkedInText"
              class="inline-block text-left pb-1 pl-1 pt-2 font-sans font-bold"
            >LinkedIn Link Text</label>
            <input type="text" v-model="linkedInText" class="block border p-1 w-64" />
          </span>
        </p>
        <p class="py-2">
          <input type="checkbox" id="use-other-link" v-model="useOtherLink" class="inline-block" />
          <label
            for="otherLink"
            class="inline-block text-left pb-1 pl-1 font-sans font-bold"
          >Other Link</label>
          <span v-if="useOtherLink">
            <label for="otherLinkURL" class="block text-left pb-1 pl-1 pt-2 font-sans font-bold">
              Link URL
              <br />
              <span style="font-weight: 100;">(be sure to include "http://" or "https://")</span>
            </label>
            <input type="text" v-model="otherLinkURL" class="block border p-1 w-64" />
            <label
              for="otherLinkText"
              class="inline-block text-left pb-1 pl-1 pt-2 font-sans font-bold"
            >Link Text</label>
            <input type="text" v-model="otherLinkText" class="block border p-1 w-64" />
          </span>
        </p>
      </div>
      <div id="right-side" class="pl-8 my-auto">
        <div id="sig">
          <table
            cellpadding="0"
            cellspacing="0"
            border="0"
            width="400px"
            style="background: none; border-width: 0px; border: 0px; margin: 0; padding: 0; font-family: futura, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; width: 400px;"
          >
            <tr>
              <td
                valign="middle"
                style="padding-top: 0; padding-bottom: 0; padding-left: .1em; padding-right: .5em; width: 100px; border-top: 0; border-bottom: 0; border-left: 0; border-right: solid 3px #ed7a23;"
              >
                <a
                  href="https://corp.inntopia.com?utm_source=email&utm_medium=signature"
                  style="text-decoration: none;"
                >
                  <img
                    id="preview-image-url"
                    src="../assets/greyemail100.png"
                    alt="&nbsp;&nbsp;INNTOPIA"
                    style="text-decoration: none; font-family: futura-pt, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; color: #333333; letter-spacing: .15em; width: 90%; padding-right: .5em;"
                  />
                </a>
              </td>
              <td
                border="0"
                style="padding-top: 0; padding-bottom: 0; padding-left: 1em; padding-right: 0; border: 0; width: 300px;"
              >
                <table
                  cellpadding="0"
                  cellspacing="0"
                  border="0"
                  style="background: none; border-width: 0px; border: 0px; margin: 0; padding: 0; line-height: 1em; text-align: left; width: 300px;"
                >
                  <tr>
                    <td
                      colspan="2"
                      style="padding-bottom: 1px; color: #ed7a23; font-size: .8em; font-family: futura-pt, futura, Arial, Helvetica, sans-serif; font-weight:600; border: 0px;"
                    >{{name}}</td>
                  </tr>
                  <tr>
                    <td
                      colspan="2"
                      style="color: #333333; font-size: 80%; font-family: futura-pt, futura, Arial, Helvetica, sans-serif; font-weight: 500; border: 0;"
                    >{{title}}</td>
                  </tr>
                  <tr v-if="useWorkPhone">
                    <td
                      colspan="2"
                      style="color: #333333; font-size: 80%; font-family: futura-pt, futura, Arial, Helvetica, sans-serif; border: 0;"
                    >
                      <span style="color: #ed7a23; border: 0; font-weight: 500;">w:</span>
                      {{workPhone}}
                    </td>
                  </tr>
                  <tr v-if="useCellPhone">
                    <td
                      colspan="2"
                      style="color: #333333; font-size: 80%; font-family: futura-pt, futura, Arial, Helvetica, sans-serif; border: 0;"
                    >
                      <span style="color: #ed7a23;  border: 0; font-weight: 500;">c:</span>
                      {{cellPhone}}
                    </td>
                  </tr>
                  <tr v-if="useSkype">
                    <td
                      colspan="2"
                      style="color: #333333; font-size: 80%; font-family: futura-pt, futura, Arial, Helvetica, sans-serif; border: 0;"
                    >
                      <span style="color: #ed7a23; border: 0; font-weight: 500;">skype:</span>
                      {{skype}}
                    </td>
                  </tr>
                  <tr>
                    <td
                      valign="top"
                      style="vertical-align: top; color: #333333; font-size: 80%; font-family: futura-pt, futura, Arial, Helvetica, sans-serif; border: 0;"
                    >
                      <a
                        v-bind:href="emailURL"
                        style="color: #61A273; text-decoration: none; font-weight: normal; font-size: 80%; border: 0;"
                      >{{email}}</a>
                    </td>
                  </tr>
                  <tr v-if="usePersonalTwitter">
                    <td
                      style="vertical-align: top; width: 20px; color: #ed7a23; font-size: 80%; font-family: futura-pt, futura, Arial, Helvetica, sans-serif; border: 0;"
                    >
                      <a
                        v-bind:href="twitterURL"
                        style="color: #61A273; text-decoration: none; font-weight: normal; font-size: 80%; border: 0;"
                      >{{twitterHandle}}</a>
                    </td>
                  </tr>
                  <tr v-else>
                    <td
                      style="vertical-align: top; width: 20px; color: #ed7a23; font-size: 80%; font-family: futura-pt, futura, Arial, Helvetica, sans-serif; border: 0;"
                    >
                      <a
                        href="https://twitter.com/inntopia"
                        style="color: #61A273; text-decoration: none; font-weight: normal; font-size: 80%; border: 0;"
                      >@inntopia</a>
                    </td>
                  </tr>
                  <tr v-if="useLinkedIn">
                    <td
                      style="vertical-align: top; width: 20px; color: #ed7a23; font-size: 80%; font-family: futura-pt, futura, Arial, Helvetica, sans-serif; border: 0;"
                    >
                      <a
                        v-bind:href="linkedInURL"
                        style="color: #61A273; text-decoration: none; font-weight: normal; font-size: 80%; border: 0;"
                      >{{linkedInText}}</a>
                    </td>
                  </tr>
                  <tr v-if="useOtherLink">
                    <td
                      style="vertical-align: top; width: 20px; color: #ed7a23; font-size: 80%; font-family: futura-pt, futura, Arial, Helvetica, sans-serif; border: 0;"
                    >
                      <a
                        v-bind:href="otherLinkURL"
                        style="color: #61A273; text-decoration: none; font-weight: normal; font-size: 80%; border: 0;"
                      >{{otherLinkText}}</a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 0;">&nbsp;</td>
            </tr>
          </table>
          <div v-if="selectedAd.id" style="text-decoration: none; color: #ed7a23;">
            <a
              v-bind:href="selectedAd['email-signature-url']"
              style="color: #ed7a20; text-decoration: none; font-weight: 600; border: 0; font-size: 0.8em; font-family: 'futura-pt', futura, Arial, Helvetica, sans-serif;"
            >{{selectedAd['email-signature-text']}} &rarr;</a>
          </div>
        </div>
        <div id="copy-button" class="text-left mt-4">
          <button
            v-on:click="selectSignature"
            class="w-64 border text-blue border-blue rounded p-2 mt-2 shadow hover:bg-blue-lighter hover:text-blue-dark replace-focus"
          >Select & Copy Signature</button>
        </div>
      </div>
    </div>
    <div id="ads" class="mt-4 mb-2">
      <h3 class="font-sans pb-2">Choose a signature ad</h3>
    </div>
    <input type="radio" name="selectedAd" value="none" v-model="selectedAd" />
    <label for="selectedAd" class="pl-2">none</label>
    <div v-for="ad in ads" v-bind:key="ad.id">
      <input type="radio" class="mt-2" name="selectedAd" :value="ad" v-model="selectedAd" />
      <label
        for="selectedAd"
        class="inline-block pl-2 font-sans text-orange-dark font-medium"
      >{{ ad['email-signature-text'] }} &rarr;</label>
    </div>
  </div>
</template>

<script>
import { log } from "util";
export default {
  name: "Signature",
  data: function() {
    return {
      name: "",
      title: "",
      useWorkPhone: false,
      workPhone: "",
      useCellPhone: false,
      cellPhone: "",
      email: "",
      useSkype: false,
      skype: "",
      usePersonalTwitter: false,
      twitterHandle: "",
      useLinkedIn: false,
      linkedInURL: "",
      linkedInText: "",
      useOtherLink: false,
      otherLinkURL: "",
      otherLinkText: "",
      ads: [],
      selectedAd: {}
    };
  },
  ls: {
    ls_name: {
      type: String,
      default: "Ned Ryerson"
    },
    ls_title: {
      type: String,
      default: "Needlenose Ned"
    },
    ls_workPhone: {
      type: String,
      default: "800-LYF-NSUR"
    },
    ls_cellPhone: {
      type: String,
      default: "888-CALL-NED"
    },
    ls_email: {
      type: String,
      default: "NedTheHead@actuarial-tables.com"
    },
    ls_skype: {
      type: String,
      default: "am-i-right-or-am-i-right"
    },
    ls_twitterHandle: {
      type: String,
      default: "@whistling_belly_button"
    },
    ls_linkedInURL: {
      type: String,
      default: "https://www.linkedin.com/company/inntopia/"
    },
    ls_linkedInText: {
      type: String,
      default: "Find me on LinkedIn"
    },
    ls_otherLinkURL: {
      type: String
    },
    ls_otherLinkText: {
      type: String
    },
    ls_useCellPhone: {
      type: Boolean
    },
    ls_useWorkPhone: {
      type: Boolean
    },
    ls_useSkype: {
      type: Boolean
    },
    ls_usePersonalTwitter: {
      type: Boolean
    },
    ls_useLinkedIn: {
      type: Boolean
    },
    ls_useOtherLink: {
      type: Boolean
    }
  },
  mounted: function() {
    // loop through all _properties on the $ls localStorage Object
    // For each one, assign the value to the corresponding $data Object
    // $ls properties are named the same as $data properties, with "ls_" prepended
    for (const lsPropName in this.$ls._properties) {
      if (this.$ls._properties.hasOwnProperty(lsPropName)) {
        const dataPropName = lsPropName.replace("ls_", "");
        const value = this.$ls.get(lsPropName);
        this.$data[dataPropName] = value;
      }
    }
    window.data = this.$data;
    this.fetchSignatures();
  },
  computed: {
    twitterURL: function() {
      return "https://twitter.com/" + this.twitterHandle;
    },
    emailURL: function() {
      return "mailto:" + this.email;
    }
  },
  methods: {
    fetchSignatures: function() {
      const baseURI =
        "https://corp.inntopia.com/wp-json/wp/v2/email_signatures";
      this.axios.get(baseURI).then(response => {
        this.ads = response.data;
      });
    },
    reverseMessage: function() {
      this.message = this.message
        .split("")
        .reverse()
        .join("");
    },
    selectSignature: function() {
      var text = document.getElementById("sig");
      var selection = window.getSelection();
      var range = document.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
      //add to clipboard.
      document.execCommand("copy");
      this.persist();
    },
    persist: function() {
      for (const dataPropName in this.$data) {
        if (this.$data.hasOwnProperty(dataPropName)) {
          const lsPropName = "ls_" + dataPropName;
          const value = this.$data[dataPropName];
          // console.log(dataPropName + ": " + value);
          this.$ls.set(lsPropName, value);
        }
      }
    }
  }
};
</script>
